import { Injector, NgModule, NgZone, runInInjectionContext } from '@angular/core';
import { MobileAuthRoutingModule } from './mobile-auth-routing.module';
import { Store, StoreModule } from '@ngrx/store';
import { authReducer, featureName } from 'src/app/auth/store/auth.reducer';
import { EffectsModule } from '@ngrx/effects';
import { MobileAuthEffects } from './store/mobile-auth.effects';
import { InactivityTimeDialogModule } from 'src/app/auth/shared/inactivity-time-dialog/inactivity-time-dialog.module';
import { MobileAuthService } from './services/mobile-auth.service';
import { MobileAuthMockService } from './services/mobile-auth-mock.service';
import { biometricsFeature } from '../biometrics/store/biometrics.store';
import * as BiometricsEffects from '../biometrics/store/biometrics.effects';
import { BiometricsService } from '../biometrics/services/biometrics.service';
import { PreferencesService } from '../biometrics/services/preferences.service';
import { MobileStartFlowModule } from '../start-flow/mobile-start-flow.module';
import { versionReviewFeature } from '../version-review/store/version-review.store';
import { VersionReviewService } from '../version-review/services/version-review.service';
import * as VersionReviewEffects from '../version-review/store/version-review.effects';
import { AuthGuard } from '../../../auth/guards/auth.guard';
import { AndroidShareSheetPluginService } from '../files/services/android-share-sheet-plugin.service';
import { IosShareExtensionDataPluginService } from '../files/services/ios-share-sheet-plugin.service';
import { shareFileWithSdFeature } from '../files/store/share-file-with-sd.store';
import { ShareFileWithSdEffects } from '../files/store/share-file-with-sd.effects';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';
import { ClientNames } from '../../client-names.enum';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { AppState } from 'src/app/reducers';

@NgModule({
  imports: [
    MobileAuthRoutingModule,
    StoreModule.forFeature(featureName, authReducer),
    StoreModule.forFeature(biometricsFeature),
    StoreModule.forFeature(shareFileWithSdFeature),
    StoreModule.forFeature(versionReviewFeature),
    EffectsModule.forFeature([
      MobileAuthEffects,
      BiometricsEffects,
      VersionReviewEffects,
      ShareFileWithSdEffects,
    ]),
    InactivityTimeDialogModule,
    MobileStartFlowModule,
  ],
  providers: [
    {
      provide: MobileAuthService,
      useFactory: (
        injector: Injector,
        store: Store<AppState>,
        router: Router,
        zone: NgZone,
        auth0Service: AuthService,
      ) => {
        const isNativePlatform = Capacitor.isNativePlatform();
        const isMobileClient = environment.appName === ClientNames.mobile;
        const isProduction = environment.production;

        if (!isMobileClient) {
          throw new Error(
            'MobileAuthModule solo debe usarse con environment.appName === ClientNames.mobile',
          );
        }

        if (isProduction || isNativePlatform) {
          // NOTE: MobileAuthService uses inject() internally, so it must be
          // instantiated within an injection context.
          return runInInjectionContext(injector, () => new MobileAuthService());
        }

        return new MobileAuthMockService(store, router, zone, auth0Service);
      },
      deps: [Injector, Store, Router, NgZone, AuthService],
    },
    BiometricsService,
    PreferencesService,
    VersionReviewService,
    AuthGuard,
    AndroidShareSheetPluginService,
    IosShareExtensionDataPluginService,
  ],
})
export class MobileAuthModule {}
